import * as React from 'react';
import { Button } from '@mui/material';
import { useFilterList } from '../../../../context/FilterListProvider';

interface IData {
    [key: string]: any;
}

const ChartButton: React.FC<IData> = ({ callback }) => {
    const [filterList] = useFilterList();
    const onShowChart = () => callback(filterList);
    return (
        <Button size="small" onClick={onShowChart} >Chart View</Button>
    );
};

export default ChartButton;
